import { useListCategoriesQuery } from "@stepapp/core";
import { Block, LinePlaceholder, spacing, Typography, useBreakpoints } from "@stepapp/ui";
import { useLocalSearchParams } from "expo-router";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet, useWindowDimensions } from "react-native";
import ServiceItem from "../../../app/(index)/ServiceItem";
import { useAppSelector } from "../../hooks";

const OtherCategories = () => {
  const { t } = useTranslation();
  const { id } = useLocalSearchParams<{ id: string }>();
  const { width: screenWidth } = useWindowDimensions();
  const localizationId = useAppSelector(({ appConfig }) => appConfig.localizationId);
  const { mobileOnly, md } = useBreakpoints();

  const { data: listCategories, loading: listCategoriesLoading } = useListCategoriesQuery({
    variables: { localizationId },
    fetchPolicy: "cache-first",
  });

  const otherCategories = useMemo(() => {
    return listCategories?.listCategories?.filter((category) => category?.id !== id)?.slice(0, 2);
  }, [listCategories, id]);

  return (
    <Block marginTop={4}>
      <Typography variant="paragraph">{t("screens.category.otherCategories")}</Typography>

      <Block row={md} style={md && styles.container}>
        {listCategoriesLoading && (
          <LinePlaceholder
            borderRadius={1}
            height={md ? 24 : 18}
            width={(screenWidth - (md ? 412 : 40)) / 8}
            marginTop={3}
          />
        )}

        {otherCategories?.map((category, index) => (
          <Block key={category?.id} flex={1}>
            <ServiceItem
              testID={`category-item-${index}`}
              key={category?.id}
              name={category?.name}
              startingPrice={category?.startingPrice}
              desktopBanner={category?.desktopUrl}
              mobileBanner={category?.mobileUrl}
              categoryItem
              id={category?.id}
              isBanner={category?.isBanner}
              bannerRedirection={category?.bannerRedirection}
              spacious={!mobileOnly}
            />
          </Block>
        ))}
      </Block>
    </Block>
  );
};

export default React.memo(OtherCategories);

const styles = StyleSheet.create({
  container: {
    gap: spacing.unit * 2,
  },
});
